(ns minorodata.json-flattening.model
  (:require [mold.core :as m :include-macros true]))

(declare ->json-flattening)

(m/defmodel json-flattening
  {:sidebar-width       [::m/number ::m/nilable "Width of the sidebar"]
   :editor-height       [::m/number ::m/nilable "Editor height"]
   :data                [::m/map ::m/nilable "Vector of results"]
   :selected-table      [::m/map "Selected table"]
   :show-select-table?  [::m/bool "Force table selector to be shown"]
   :code                [::m/string "Editor value"]
   :selected-columns    [::m/vector]
   :checked-columns     [::m/vector]
   :ordered-columns     [::m/vector]
   :structure           [::m/map]
   :error               [::m/string ::m/nilable "Error message"]}
  {:singleton true
   :keep-nils true})
